import moment from "moment";
import api from "@/modules/global/lib/api-client.js";

const state = {
  coupons: []
};

const getters = {
  allCoupons: state => {
    return state.coupons;
  }
};

const mutations = {
  setCoupons(state, couponsPayload) {
    state.coupons = couponsPayload;
  },
  newCoupon(state, newCouponPayload) {
    state.coupons.push(newCouponPayload);
  },
  updateCoupon(state, updateCouponPayload) {
    const index = state.coupons.findIndex(coupon => coupon._id === updateCouponPayload._id);
    
    if (index != -1) {
      state.coupons.splice(index, 1, updateCouponPayload);
    }
  }
};

const actions = {
  async fetchCoupons({commit}) {
    try {
      const response = await api.get('coupons/');
      
      if (response.status == 200) {
        const coupons = await response.json();
        commit("setCoupons", coupons);
      }

    } catch (error) {
      console.log(error);
    }  
  },

  async createCoupon({commit}, newCoupon){
    try {
      const response = await api.post('coupons', {
        json: {
          ...newCoupon
        }
      })
      
      if (response.status == 200) {
        const newCouponData = await response.json();
        commit("newCoupon", newCouponData.coupon);
      }
      return response.status;
    } catch (error) {
      console.log(error)
      return error;
    }
  },

  async updateCoupon({commit}, updateCoupon){
    try {
      const response = await api.put(`coupons/${updateCoupon._id}`, {
        json: {
          ...updateCoupon
        }
      })

      if (response.status == 200) {
        const updateCouponData = await response.json();
        console.log(updateCouponData);
        commit("updateCoupon", updateCouponData.coupon);
      }
    } catch (error) {
      console.log(error)
    }
  }
};

export default {
  state,
  actions,
  getters,
  mutations,
  namespaced: true
};
